import { flushSync } from 'react-dom';

/** Поля, которые сами себя держат открытыми при фокусе: возвращать на них курсор нельзя — выпадающий
 *  список и календарь раскрылись бы заново. */
const NO_REFOCUS = '.ant-picker, .ant-select';

/**
 * Фиксирует значение поля, в котором стоит курсор, до того как сработает горячая клавиша.
 * `IntInput`/`MoneyInput` и календарь отдают введённое наружу на blur, а клавиатурное сочетание
 * blur не вызывает: без этого «5» в поле «Коробок» и сразу `Ctrl+Enter` провели бы документ без
 * пятёрки. Вызывать из обработчика горячей клавиши (нативное событие, не из React-обработчика).
 *
 * Поле теряет фокус внутри `flushSync` — когда функция вернулась, родитель уже получил значение и
 * перерисовался, так что обработчик, взятый из «свежей» ссылки, видит актуальные данные. Затем
 * курсор возвращается на место (дальше можно продолжать ввод после «Сохранить»). Возвращает
 * `invalid: true`, если поле не приняло ввод: об этом нельзя узнать из состояния окна — отметку
 * «поле неверное» оно получит только на следующем рендере.
 */
export function commitActiveField(): { invalid: boolean } {
  const el = document.activeElement;
  const isTextField = el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement;
  if (!isTextField || el.getAttribute('role') === 'combobox') return { invalid: false };

  flushSync(() => el.blur());
  const invalid = el.getAttribute('aria-invalid') === 'true';
  if (el.isConnected && !el.closest(NO_REFOCUS)) el.focus({ preventScroll: true });
  return { invalid };
}
